module.exports = __webpack_public_path__ + "static/img/03bg.4e26aad.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/03bg.png
// module id = CJ5B
// module chunks = 1